import {
	goToNextImage
} from './_goToNextImage';
import {
	hoverImage
} from './_hoverImage';
import {
	imgSwipe
} from './_imgSwipe';

export var navImageSliderBinds = function (facetsToCache) {
	var hoverSpeed = 1000;
	if ($('html.no-touchevents').length > 0) {
		$("img[data-alternates]").mouseover(function () {
			hoverSpeed = 500;
			var $img = $(this);
			goToNextImage($img);
			$img.data("hovered", "true");
			if ($img.data("runningAlt") != 'true') hoverImage($img);
		});

		$("img[data-alternates]").mouseleave(function () {
			$(this).data("hovered", "false");
			$(this).data("alternates", $(this).data("originalalternates"));
			goToNextImage($(this));
			$(this).data("alternates", $(this).data("originalalternates"));
		});
	}

	var facets = encodeURIComponent(facetsToCache) != 'undefined' ? "&facetCache=" + encodeURIComponent(facetsToCache) : '';

	$("a[data-swatchalternates]").click(function () {
		$(this).parents(".product-tile").find('.slickWrapper').slick('unslick');
		let mainImg = $(this).parents(".product-tile").find('[data-catentryid]').detach();
		$(this).parents(".product-tile").find('.product-img-wrapper .product-link').append(mainImg);
		$(this).parents(".product-tile").find('.slickWrapper').remove();
		$(this).parents(".product-tile").find("img[data-alternates]").data("alternates", $(this).data("swatchalternates"));
		$(this).parents(".product-tile").find("img[data-alternates]").data("originalalternates", $(this).data("swatchalternates"));
		var catentryId = $(this).attr("class").split('_')[1];
		$(".tileLink_" + catentryId).attr("href", $(".tileLink_" + catentryId).attr("href").split("&di=")[0] + "&di=" + $(this).data("swatchalternates").split("|")[0] + facets);
		goToNextImage($(this).parents(".product-tile").find("img[data-alternates]"));
		if (Dillards.config.deviceClass == 'tabletPage' || Dillards.config.deviceClass == 'mobilePage') {
			var prodId = $(this).parents('figure').attr('id'),
				dataAlts = $(this).data('swatchalternates');
			imgSwipe(prodId, dataAlts);
		}
	});

};
